// extracted by mini-css-extract-plugin
export default {"scrollToTopDiv":"scrollToTop_scrollToTopDiv__qvHaN","scrollUpDown":"scrollToTop_scrollUpDown__dN7m8","arrowDiv":"scrollToTop_arrowDiv__xY34I"};